module.exports = __webpack_public_path__ + "static/media/bg_programme.5bbf67d1.svg";